(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListFilterSidebar', rmsListFilterSidebar);

    function rmsListFilterSidebar($timeout) {
        return {
            restrict: 'E',
            link: rmsListFilterSidebarLink,
            templateUrl: 'common/app/components/list-filter/sidebar'
        };

        function rmsListFilterSidebarLink(scope, elem) {
            scope.listFilterService = scope.$parent.listFilterService;
            const vm = scope.$parent.vm;
            scope.filterViewWrapperStyle = {bottom: 0};

            vm.hideSidebar = function() {
                vm.pageData.sidebar_active = false;
                $timeout(function() {
	                vm.pageData.grid.resize();
                });
            };

            scope.showingFilterView = function() {
                const filterViewControlElem = elem.find('.filter-view-control');
                $timeout(function() {
                    vm.pageData.filterViewWrapperStyle = {
                      bottom: filterViewControlElem.outerHeight() + 'px !important',
                    };
                });
            };

            scope.viewOptionsChanged = function() {
                scope.listFilterService.refreshGrid();
            };

            scope.onViewChange = function() {
                scope.listFilterService.getFilterService().applyView();
            };

            scope.handleDeleteView = function() {
                scope.listFilterService.getFilterService().deleteView();
            };

            scope.handleUpdateView = function() {
                scope.listFilterService.getFilterService().updateView();
            };

            scope.handleSaveNewView = function() {
                scope.listFilterService.getFilterService().createView();
            };

            scope.hasAppliedFilters = function() {
                return scope.listFilterService.getFilterService().hasAppliedFilters();
            };
        }
    }
})();